import { updatesData } from '@/mocks/homeData';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-3xl mx-auto">
        <div className="flex items-center gap-2 mb-8">
          <span className="w-2 h-2 rounded-full bg-primary-500 animate-pulse-dot"></span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
            实时快讯
          </h2>
        </div>
        <div className="relative pl-6 border-l-2 border-background-200 space-y-0">
          {updatesData.map((item, idx) => (
            <div
              key={item.id}
              className={`relative pb-6 ${idx < updatesData.length - 1 ? '' : 'pb-0'}`}
            >
              <span className="absolute -left-[25px] top-1 w-3 h-3 rounded-full bg-primary-500 border-2 border-background-100"></span>
              <div>
                <span className="text-xs text-foreground-400 mb-1 block">{item.time}</span>
                <div className="flex items-start gap-2">
                  <span className={`px-1.5 py-0.5 text-xs font-semibold text-background-50 ${item.tagColor} rounded whitespace-nowrap flex-shrink-0`}>
                    {item.tag}
                  </span>
                  <a
                    href="#cards"
                    onClick={(e) => {
                      e.preventDefault();
                      document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
                    }}
                    className="text-sm font-medium text-foreground-800 hover:text-primary-600 transition-colors cursor-pointer leading-snug"
                  >
                    {item.title}
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}